import { GenericStateNoActionBlockCombinedProps } from './types';

const usePresenter = (props: GenericStateNoActionBlockCombinedProps): GenericStateNoActionBlockCombinedProps => {
  return props;
};

export default usePresenter;
